import { clearConsentGateState } from '@/lib/consentGate';
import { COOKIE_CONSENT_STORAGE_KEY, readCookieConsent } from '@/lib/cookieConsent';
import { clearAppQueryCache } from '@/lib/queryClient';
import { resetAuthenticatedUser } from '@/lib/analytics/trackers/auth';

export const USER_STORAGE_KEY = 'caloriescience_user';
export const USER_PROFILE_UPDATED_EVENT = 'caloriescience:user-profile-updated';

export const clearStoredAuthSession = () => {
  if (typeof window === 'undefined') {
    return;
  }

  const cookieConsent = readCookieConsent();

  clearAppQueryCache();
  localStorage.clear();
  if (cookieConsent) {
    localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(cookieConsent));
  }
  clearConsentGateState();
  resetAuthenticatedUser();
  window.dispatchEvent(new CustomEvent(USER_PROFILE_UPDATED_EVENT));
};
